module.exports = __webpack_public_path__ + "img/trial3-3.1e023d6d.png";